<template>
	<div class="team-detail-contact-mobile">
		<NuxtImg :src="completeImageUrl(contact.SpeakerImage)"
             :alt="contact.SpeakerImageMetadata['alt']"
             :title="contact.SpeakerImageMetadata['title']"
             loading="lazy"
             class="vh-20"
             sizes="1360px"
    />
		<div class="team-teaser">
			<div class="team-teaser__share">
				<TeamSocialSharing :contact="contact" />
				<div class="speaker-profil">
					<p>
						{{ contact.SpeakerText }}
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TeamSocialSharing from './TeamSocialSharing'
import { usePimcoreAssetUrl } from '~/composables/usePimcoreAssetUrl'
export default {
	name: 'TeamSpeakerProfil',
	components: {
		TeamSocialSharing
	},
	// eslint-disable-next-line vue/require-prop-types
	props: ['contact'],
  methods: {
    completeImageUrl(imagePath) {
      if (!imagePath) {
        return '/images/no-image-placeholder.svg'
      }
      return usePimcoreAssetUrl(imagePath)
    }
  }
}
</script>
<style lang="scss">
.team-detail-contact-mobile {
	.vh-20 {
		height: 234px;
		width: 100%;
		object-fit: cover;
		object-position: 50% 20%;
		margin-bottom: 20%;
		margin: 0;
	}
}
</style>
